// src/components/Layout.jsx

import React from 'react';
import Navigation from './Navigation';
import ContactFooter from './ContactFooter';

const Layout = ({ children }) => {
    return (
        <div className="app-layout">
            <Navigation />
            {/* paddingBottom clears the fixed ContactFooter bar so page content
                (e.g. Continue buttons) is never hidden behind it. */}
            <main className="main-content" style={{ paddingBottom: '80px' }}>
                {children}
            </main>
            {/* Global support footer — available on every Layout-wrapped page
                so users can report an issue from wherever they are. */}
            <ContactFooter />
        </div>
    );
};

export default Layout;